import { useState } from 'react'
import { Input, Select, Textarea } from '../../components/forms'
import Button from '../../components/ui/Button'
import { formatDateInput } from '../../lib/format'

const TYPE_OPTIONS = [
  { value: 'expense', label: 'Expense' },
  { value: 'revenue', label: 'Revenue' },
]

const CATEGORY_OPTIONS = [
  { value: 'software', label: 'Software & Tools' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'hosting', label: 'Hosting & Infrastructure' },
  { value: 'services', label: 'Professional Services' },
  { value: 'supplies', label: 'Office Supplies' },
  { value: 'salary', label: 'Salary & Wages' },
  { value: 'sales', label: 'Sales' },
  { value: 'consulting', label: 'Consulting' },
  { value: 'other', label: 'Other' },
]

function TransactionForm({ initialData, onSubmit, onCancel, loading = false }) {
  const [formData, setFormData] = useState({
    date: formatDateInput(initialData?.date || new Date()),
    type: initialData?.type || 'expense',
    description: initialData?.description || '',
    amount: initialData?.amount || '',
    category: initialData?.category || '',
    notes: initialData?.notes || '',
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      amount: parseFloat(formData.amount),
    })
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-2">
        <Input
          label="Date"
          name="date"
          type="date"
          value={formData.date}
          onChange={handleChange}
          required
        />
        <Select
          label="Type"
          name="type"
          value={formData.type}
          onChange={handleChange}
          options={TYPE_OPTIONS}
        />
      </div>

      <Input
        label="Description"
        name="description"
        value={formData.description}
        onChange={handleChange}
        placeholder="What was this transaction for?"
        required
      />

      <div className="grid grid-2">
        <Input
          label="Amount"
          name="amount"
          type="number"
          step="0.01"
          min="0"
          value={formData.amount}
          onChange={handleChange}
          placeholder="0.00"
          required
        />
        <Select
          label="Category"
          name="category"
          value={formData.category}
          onChange={handleChange}
          options={CATEGORY_OPTIONS}
          placeholder="Select category..."
        />
      </div>

      <Textarea
        label="Notes"
        name="notes"
        value={formData.notes}
        onChange={handleChange}
        placeholder="Additional details..."
        rows={2}
      />

      <div className="flex justify-between gap-3 mt-6">
        <Button type="button" variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="submit" variant="primary" loading={loading}>
          {initialData ? 'Update' : 'Add'} Transaction
        </Button>
      </div>
    </form>
  )
}

export default TransactionForm
